<template>
  <div>
    <CRow class="top-content">
      <CCol sm="6">
        <CCard>
          <CCardHeader> کلاس در حال برگزاری </CCardHeader>
          <CCardBody class="d-flex align-items-center h-100">
            <div v-if="activeCourses.length > 0" class="w-100 h-100">
              <div
                  v-for="course in activeCourses"
                  :key="course.id"
                  class="active-course__wrapper w-100 d-flex justify-content-between h-100"
              >
                <div>
                  <div class="d-flex flex-column align-items-start">
                    <h5 class="gray-800">{{ course.course.name }}</h5>
                  </div>

                  <div class="gray-800 text-sm">
                    {{ course.endTime }} -
                    {{ course.startTime }}
                  </div>
                </div>

                <CButton
                  :disabled="loading"
                  color="primary"
                  class="align-self-end px-4 text-white"
                >
                  <a :href="course.link" target="_blank">
                    ورود به کلاس
                  </a>
                </CButton>
              </div>
            </div>
            <div v-else class="w-100 gray-800">
              <h5>در حال حاضر کلاسی</h5>
              <h5>در حال برگزاری ندارید</h5>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="6">
        <TimeCard />
      </CCol>
    </CRow>

    <DashboardNews />

    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader> جدول کلاس‌ها </CCardHeader>
          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
              class="w-100 d-flex justify-content-between h-100"
              :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
              :items="computedWeeklySchedule"
              :fields="klassFields"
              hover
              striped
              border
              small
              fixed
              :loading="loading"
            >
              <template #course="{ item }">
                <td>
                  <div
                    class="w-100 d-flex align-content-start text-center h-100"
                  >
                    <div
                      v-for="schedule in item.time"
                      :key="schedule.id"
                      :class="[setScheduleActive(schedule.active)]"
                      class="schedule d-flex flex-column align-items-center"
                    >
                      <h5>{{ schedule.course.name }}</h5>
                      <h6 class="gray-600">
                        {{ schedule.course.klass.grade.name }}
                        {{ schedule.course.klass.name }}
                      </h6>
                      <div class="gray-600 text-sm">
                        {{ schedule.endTime }} - {{ schedule.startTime }}
                      </div>
                    </div>
                  </div>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import axios from "@/plugins/axios";
import TimeCard from "@/components/TimeCard/TimeCard.vue";
import DashboardNews from "@/components/DashboardNews/DashboardNews.vue";

export default {
  name: "TeacherDashboard",
  components: { TimeCard, DashboardNews },

  data() {
    return {
      loading: false,
      activeCourses: [],
      weeklySchedule: [],
      klassFields: [
        { key: "day", label: "روز" },
        { key: "course", label: "درس ها" },
      ],
    };
  },
  computed: {
    computedWeeklySchedule() {
      return this.weeklySchedule.map((item) => {
        return {
          ...item,
          day: `${item.day}`,
        };
      });
    },
  },
  mounted() {
    this.getCourses();
    this.getActiveCourse();
  },
  methods: {
    async getActiveCourse() {
      try {
        this.loading = true;
        const { data } = await axios.get("/course/active");
        this.activeCourses = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getCourses() {
      try {
        this.loading = true;
        const { data } = await axios.get("/course/time");
        this.weeklySchedule = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    setScheduleActive(isActive) {
      return isActive ? "active" : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.top-content {
  .card {
    min-height: calc(100% - 24px);
  }
}

.schedule {
  margin-left: 8px;
  padding: 10px;
  border-radius: 5px;
  border: 2px solid #ced2d8;
  min-width: 130px;
  //background-color: #ced2d8;
}
.active {
  background-color: rgba(46, 184, 92, 0.25);
}
::v-deep {
  th {
    font-size: 16px;
  }

  td {
    font-size: 14px;
  }
}

a {
  color: inherit;
}

.active-course__wrapper {
  border-bottom: 1px solid #d8dbe0;
  padding: 8px 0;

  &:last-child {
    border-bottom: none;
  }
}
</style>
